import { PureComponent } from 'preact-compat'
import { ContentType } from '@insided/shared/utils/contentType'
import { REPLY } from '../../constants'

import Modal, {
  ModalHeader,
  ModalBody,
  ModalFooter
// eslint-disable-next-line import/no-internal-modules
} from '@insided/deprecated-preact-components/design-system-components/modal'
// eslint-disable-next-line import/no-internal-modules
import { ButtonGroup } from '@insided/deprecated-preact-components/design-system-components/button'
import Button from '@insided/control/uikit/Button'

export interface ToggleTrashReplyProps {
  contentType: ContentType
  topicId: number
  trashed: boolean
  onClose: () => void
  handleTrash: () => void
  onShowAlert: (type: 'success' | 'error', message?: string) => void
}

export interface ToggleTrashReplyState {
  isLoading: boolean
  errorMessage?: string
}

class ToggleTrashReplyModal extends PureComponent<ToggleTrashReplyProps, ToggleTrashReplyState> {
  constructor(props: ToggleTrashReplyProps) {
    super(props)
    this.onToggleTrashReply = this.onToggleTrashReply.bind(this)
  }

  async onToggleTrashReply() {
    const { onClose, onShowAlert, handleTrash } = this.props

    this.setState({ isLoading: true })

    try {
      await handleTrash()
      onClose()
    } catch {
      onShowAlert?.('error')
    }

    this.setState({ isLoading: false })
  }

  render() {
    const { onClose } = this.props
    const { isLoading } = this.state
    return (
      <Modal onClose={onClose} isControl>
        <ModalHeader title={`${REPLY.ACTION}?`} />
        <ModalBody>
          <p>The reply will not be visible in community.</p>
        </ModalBody>
        <ModalFooter>
          <ButtonGroup>
            <Button
              title={REPLY.ACTION} variant='warning' onClick={this.onToggleTrashReply} isLoading={isLoading}
              data-qa='trash-reply' size='medium'
            />
            <Button title='Cancel' onClick={onClose} size='medium' />
          </ButtonGroup>
        </ModalFooter>
      </Modal>
    )
  }
}

export default ToggleTrashReplyModal
